module.exports = __webpack_public_path__ + "static/customs-clearance-104bb8f0af19e799dde6f6cef44fda48.png";